import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ProblemMenuConfig } from 'src/app/state-management';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-addcase-categories',
    templateUrl: './addcase-categories.component.html',
    styleUrls: ['./addcase-categories.component.scss'],
    standalone: false
})
export class AddcaseCategoriesComponent implements OnInit, OnChanges {
  @Input() fg: UntypedFormGroup;
  @Input() menuConfig: ProblemMenuConfig[];
  @Output() outPutNextStep = new EventEmitter<ProblemMenuConfig>();
  menu: any = [];
  selectedMenuOne: string;
  selectedMenuTwo: string;
  message = '';

  constructor() { }

  ngOnInit() {
    // console.log(this.menuConfig);
  }

  ngOnChanges() {
    if (this.menu.length === 0 && this.menuConfig.length > 0) {
      this.menu = buildMenu(this.menuConfig.filter(m => m.showMenu));
      //  console.log(this.menu);
    }
  }

  nextStep(pt: ProblemMenuConfig) {
    this.fg.get('group').setValue(pt.group_RefId);
    this.fg.get('problemType').setValue(pt.problemType_RefId);
    this.outPutNextStep.emit(pt);
  }

  nextOrMenu(menuTwo: any) {
    this.message = '';
    const menuItems = this.menuConfig.filter(m => m.showMenu && m.menuTwo === menuTwo.item && m.menuOne === this.selectedMenuOne);
    if (menuItems.length === 1 && menuItems[0].menuThree.length === 0) {
      if (menuItems[0].message !== '') {
        this.message = menuItems[0].message;
      } else {
        this.nextStep(menuItems[0]);
      }

    } else {
      this.menuTwoClick(menuTwo.item);
    }
  }

  menuThreeNextStep(menuThree: any) {
    const item = this.menuConfig.filter(m => m.showMenu && m.menuThree === menuThree
      && m.menuTwo === this.selectedMenuTwo && m.menuOne === this.selectedMenuOne);
    if (item[0].problemType_RefId !== null) {
      this.nextStep(item[0]);
    } else {
      this.message = item[0].message;
      this.scrollToTop();
    }

  }

  scrollToTop() {
    document.querySelector('#top')
      .scrollIntoView(true);
  }

  menuOneClick(val: any) {
    this.message = '';
    if (this.selectedMenuOne === val) {
      this.selectedMenuOne = '';
    } else {
      this.selectedMenuOne = val;
    }
    if (val === 'Noise') {
      const pt = this.menuConfig.filter(mc => mc.showMenu && mc.menuOne === val);
      this.nextStep(pt[0]);
    }
  }

  menuTwoClick(val: any) {
    if (this.selectedMenuTwo === val) {
      this.selectedMenuTwo = '';
    } else {
      this.selectedMenuTwo = val;
    }
    // console.log(this.selectedMenuTwo);
  }


}
export function buildMenu(menuConfig: ProblemMenuConfig[]): any {
  const builtMenu: {
    menuOne: [
      {
        item: string, menuTwo: [
          {
            item: string,
            menuThree: string[]
          }
        ]
      }]
  } = {} as any;
  // console.log(this.menuConfig);
  const menuOne: any = menuConfig
    .map((menu: { menuOne: any; }) => menu.menuOne).filter((value, index, self) => self.indexOf(value) === index);
  builtMenu.menuOne = [] as any;
  menuOne.forEach((a: any) => {
    const level2 = menuConfig
      .filter((x: { menuOne: any; }) => x.menuOne === a)
      .map((menu: { menuTwo: any; }) => menu.menuTwo)
      .filter((value, index, self) => self.indexOf(value) === index);

    const temp1 = { item: a, menuTwo: [] as any };

    let menuTwoOther = {};
    level2.forEach((b: any, idx: number) => {

      const level3 = menuConfig
        .filter((c: { menuTwo: any; menuOne: any; }) => c.menuTwo === b && c.menuOne === a)
        .map((menu: { menuThree: any; }) => menu.menuThree)
        .filter((value, index, self) => self.indexOf(value) === index);
      const temp2 = { item: b, menuThree: level3.length === 1 && level3[0] === '' ? null : level3 };

      // reorder menu three with 'other' RAP-370
      if (temp2.menuThree !== null) {
        const otherPosition = temp2.menuThree.indexOf('Other');
        if (otherPosition > -1) {
          const menuThreeOther = temp2.menuThree[otherPosition];
          temp2.menuThree.splice(otherPosition, 1);
          temp2.menuThree.push(menuThreeOther);
        }
      }

      // RAP-370 put other at end of list
      if (temp2.item !== 'Other') {
        temp1.menuTwo.push(temp2);
      } else {
        menuTwoOther = temp2;
      }

      if (idx === level2.length - 1 && Object.keys(menuTwoOther).length > 0) {
        temp1.menuTwo.push(menuTwoOther);
        menuTwoOther = {};
      }
    });

    builtMenu.menuOne.push(temp1);

  });
  // console.log(builtMenu);
  return builtMenu;
}
